var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LocationsPage',{attrs:{"header":_vm.header,"crumbs":_vm.crumbs,"bodyTop":_vm.bodyTop,"bodyBottom":_vm.bodyBottom,"heroText":_vm.heroText,"subLocations":_vm.subLocations,"image":"../img/locations/nj.jpeg"}})}
var staticRenderFns = []

export { render, staticRenderFns }